import Vue from 'vue'
import create from './create'
import {OK} from 'http-status-codes'
import {make} from 'vuex-pathify'
import {byId, crudifyMutations} from 'src/utilities/vuex2'
import {ptracGetEntities} from 'src/utilities/ptracApi'
import {urlEncode} from 'src/utilities/utils'

const initialState = {
  query: {
    customerName: null,
    refNumber: null,
    refNumberIsNull: false
  },
  results: [],
}

const state = Vue.util.extend({}, JSON.parse(JSON.stringify(initialState)))

const getters = make.getters(state)
getters.byId = byId

const mutations = make.mutations(state)
mutations.resetQuery = (state) => {
  state.query = JSON.parse(JSON.stringify(initialState.query))
}
mutations.resetResults = (state) => {
  state.results = []
}

crudifyMutations(mutations)

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions: {
    async fetchResults({ state }) {
      state.results = []
      const customerName = state.query.customerName
      const refNumber = state.query.refNumber
      const refNumberIsNull = state.query.refNumberIsNull

      let queryUrl = 'invoices/search/'
      const customerNameForUrl = '?customerName=' + urlEncode(customerName)
      const refNumberForUrl = 'refNumber=' + urlEncode(refNumber)

      if (customerName && refNumber) {
        queryUrl += 'findByCustomerNameContainsIgnoreCaseAndRefNumberOrderByTxnDateDesc' + customerNameForUrl + '&' + refNumberForUrl
      } else if (customerName && !refNumber) {
        queryUrl += 'findByCustomerNameContainsIgnoreCase'
        if (refNumberIsNull) {
          queryUrl += 'AndRefNumberIsNull'
        }
        queryUrl += 'OrderByTxnDateDesc' + customerNameForUrl
      } else if (!customerName && refNumber) {
        queryUrl += 'findByRefNumberOrderByTxnDateDesc?' + refNumberForUrl
      } else if (!customerName && !refNumber && refNumberIsNull) {
        queryUrl += 'findByRefNumberIsNullOrderByTxnDateDesc'
      }

      const response = await ptracGetEntities(queryUrl)

      if (OK === response.status) {
        state.results = response.data
      }

      return response
    }
  },
  modules: {
    create
  }
}
